Shopify.customCart = Shopify.customCart || {};
Shopify.customCart.formatMoney = function(value) {
  return Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:2}).format(value);
}
const setSubTotal = (data) => {
  
  const formattedSubtotal = Shopify.customCart.formatMoney(data.items_subtotal_price/100);
  
  document.querySelector('.subtotal-top').innerHTML = `<span>Subtotal:</span> <span>${formattedSubtotal}</span>`;
  document.querySelector('[data-cart-subtotal]').innerHTML = formattedSubtotal;
};

$(document).ready(function () {
  // Remove handling Shipping and Tax products here
  var handling = $(".handling-product").html();
  if(handling == 'true'){
    let changePromises = [];
  
    const cartdata = fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [43033812107448] : 0, [43032880480440] : 0, [43033812762808] : 0 } }),
    }).then((response) => {
      return response.json();
    }).then((data) => {
      setSubTotal(data);
      data.items.forEach((item, index) => {
      const addressAsJSONStringified = item.properties['_address'];
      const address = typeof addressAsJSONStringified === 'string' ? JSON.parse(addressAsJSONStringified) : addressAsJSONStringified;
    
      item.properties['_address'] = address;
      item.properties['_address_string'] = item.properties['Address'];
      let changes = {
        line: index,
        properties: {
          ...item.properties,
        }
      };
      changePromises.push(fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(changes)
      }).then(res => res.json()));
    });
    Promise.all(changePromises).then((datadone) => {
      return datadone;
    }).then((data) => {
      
    });
    });
  }
  $(".cart_gift_message, .cart_gift_message_added").click(function (e) {
      let CartLine = $(this).data("line"),
          gTo = $(this).data("gto"),
          gFrom = $(this).data("gfrom"),
          gMessage = $(this).data("gmessage");

      $("#RecipientName").val(gTo);
      $("#SenderName").val(gFrom);
      $("#GiftMessage").val(gMessage);
      $("#CartLine").val(CartLine);
      $('.char-counter').hide();
  });

  $("#giftButton").click(async function () {
      let gTo = $("#RecipientName").val(),
          gFrom = $("#SenderName").val(),
          gMessage = $("#GiftMessage").val(),
          CartLine = $("#CartLine").val(),
          cart = await $.ajax({
              type: "GET", dataType: "json", url: "/cart.js", success: (data) => {
                  return (data);
              }
          }),
          cartItem = cart.items[+CartLine - 1],
          properties = {...cartItem.properties, ...{'To': gTo, 'From': gFrom, 'Message': gMessage}},
          formData = {
              'line': CartLine,
              'quantity': cartItem.quantity, 
              'properties': properties
          };

      fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      }).then(response => {
          window.location.reload();
          return response.json();
      }).catch((error) => {
          console.error('Error:', error);
      });
  });

 // Disable checkout option
 function checkoutButtonUpdate(){
  $('#checkoutBottom').prop('disabled', false);
  $('#checkoutTop').prop('disabled', false);
  var lineItem = 1;
  $(".selected-address").removeClass("invalid");
  $(".form-error-msg").hide();

  if ($("input.selected-address").length == 1) {
    // If only one line item, then override the checkout button to go to the Shipping Address Modal, for UX
    if ($("input.selected-address").val() == "") {
      
      // If address not set, change the checkout button to "Set Shipping Address", and change click action to popup modal
      $('#checkoutTop,#checkoutBottom').text("Set Shipping Address").addClass("address");
      $('h2.form__message').hide();
    } else {
      
      // If address set, revert the checkout button to Check Out and change click action back to go to cart page
      $('#checkoutTop,#checkoutBottom').text("Check Out").removeClass("address");
      $('h2.form__message').show();
    }
    // End only one line item
  } else {
    // Otherwise, check all line items and disable the checkout button
    $("input.selected-address").each(function(){
      
      if($(this).val() == ""){
        $(this).addClass('invalid');
        $(".form-error-msg").show();
        $('#checkoutBottom').prop('disabled', true);
        $('#checkoutTop').prop('disabled', true);
        //$(".duplicate-item.duplicate-"+lineItem).hide();
      }else{
        //$(".duplicate-item.duplicate-"+lineItem).show();
      }
      lineItem += 1;
    });
  }
}

//Initialising the function
checkoutButtonUpdate();

$(document).on('click','.button--tertiary',function(){
  setTimeout(function () {
    checkoutButtonUpdate();
  }, 1500);
});

$(document).on('click','.saved-address-item',function(){
  setTimeout(function () {
    checkoutButtonUpdate();
  }, 1500);
});

$(document).on('click','.modal-address__footer',function(){
  setTimeout(function () {
    checkoutButtonUpdate();
  }, 2500);
});

document.querySelectorAll('.gift__checkbox-wrapper label').forEach((giftMessageLabel) => {
  giftMessageLabel.addEventListener('click',async function(e) {
    if (e.target.closest('label').querySelector('.gift__custom-checkbox').classList.contains('checked')) {
      let CartLine = e.target.closest('.cart-item').id.replace('CartItem-',''),
      cart = await $.ajax({
          type: "GET", dataType: "json", url: "/cart.js", success: (data) => {
              return (data);
          }
      }),
      cartItem = cart.items[+CartLine - 1],
      properties = {...cartItem.properties};
      properties.To = null;
      properties.From = null;
      properties.Message = null;
      let formData = {
          'line': CartLine,
          'properties': properties
      };

      fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      }).then(response => {
          window.location.reload();
          return response.json();
      }).catch((error) => {
          console.error('Error:', error);
      });
    } else {
      e.target.closest('.gift__checkbox-wrapper').querySelector('modal-opener button').click();
    }
  })
});

// Duplicate Line Items logics
$(document).on('click','.duplicate-item',function(){
  var id = parseInt($(this).data('id'));
  var index = parseInt($(this).data('index'));
  var productObj = JSON.parse($('.item-properties.'+index).html()).properties;
  if((productObj._cpb_configId == undefined)&&(productObj._Includes == undefined)){
    var cartItem = {
   'items': [{
      'id': id,
      'quantity': 1,
      'properties': {
        //'Message': productObj.Message,
        //'To':productObj.To,
        //'From': productObj.From,
        'Customizations': productObj.Customizations,
        '_cpb_customMessage': productObj._cpb_customMessage,
        '_cpb_bottomColor': productObj._cpb_bottomColor,
        '_cpb_topColor': productObj._cpb_topColor,
        '_image': productObj._image
      }
      }]
  };
  }else if(productObj._Includes != undefined){
    var cartItem = {
   'items': [{
      'id': id,
      'quantity': 1,
      'properties': {
        //'Message': productObj.Message,
        //'To':productObj.To,
        //'From': productObj.From,
        '_product_id': productObj._product_id,
        '_image': productObj._image,
        '_Includes': productObj._Includes,
        'Includes': productObj.Includes,
        '_image': productObj._image
      }
      }]
  };
  }else{
    var cartItem = {
   'items': [{
      'id': id,
      'quantity': 1,
      'properties': {
        //'Message': productObj.Message,
        //'To':productObj.To,
        //'From': productObj.From,
        'Customizations': productObj.Customizations,
        '_cpb_configId': productObj._cpb_configId,
        '_cpb_productUrl': productObj._cpb_productUrl,
        '_product_id': productObj._product_id,
        '_cpb_customMessage': productObj._cpb_customMessage,
        '_cpb_bottomColor': productObj._cpb_bottomColor,
        '_cpb_topColor': productObj._cpb_topColor,
        '_image': productObj._image,
        'SKU': productObj.SKU
      }
      }]
    };
  }
  if (!productObj._address) {
    cartItem.items[0].properties._rand = Math.floor(Math.random()*10000);
  }

fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(cartItem)
  })
  .then(response => {
    window.location.reload();
    return response.json();
  })
  .catch((error) => {
      console.error('Error:', error);
  });

 });
});
